import { render, staticRenderFns } from "./UdemyAccess.vue?vue&type=template&id=a35d84ec&scoped=true"
import script from "./UdemyAccess.vue?vue&type=script&lang=js"
export * from "./UdemyAccess.vue?vue&type=script&lang=js"
import style0 from "./UdemyAccess.vue?vue&type=style&index=0&id=a35d84ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35d84ec",
  null
  
)

export default component.exports